function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ModalStructure from './ModalStructure';
import { TrapFocus } from '@homeaway/a11y-tools';
import { checkElementType } from './utils';
import "./Modal.css";
import "./Modal-variations.css";
import "./Modal-animations.css";
var KEYCODES = {
  ESCAPE: 27,
  TAB: 9
};
var TIMEOUTS = {
  backdrop: {
    transitionEnterTimeout: 250,
    transitionExitTimeout: 250
  },
  modal: {
    transitionEnterTimeout: 350,
    transitionExitTimeout: 350
  }
};
var STATE_ENUM = {
  OPEN: 1,
  CLOSING: 2
};

var Modal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Modal, _Component);

  function Modal(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleOpen = function () {
      _this.addBodyClasses();

      if (typeof window !== 'undefined') {
        _this.focusedElementBeforeOpen = window.document.activeElement;

        _this.addListeners();

        _this.trapFocus.determineFocusable(_this.modalStructure.dialog);

        _this.handleFirstFocus();
      }

      if (_this.props.onModalOpen) {
        _this.props.onModalOpen(_this.modalStructure, _this.modalBodyElement);
      }
    };

    _this.handleClose = function () {
      _this.removeBodyClasses();

      if (typeof window !== 'undefined') {
        // ensure that that focusedElementBefore is an element with focus()
        // a11y: return focus to item that was focused before opening modal
        if (_this.focusedElementBeforeOpen && typeof _this.focusedElementBeforeOpen.focus === 'function') {
          _this.focusedElementBeforeOpen.focus();
        }

        _this.removeListeners();
      }

      if (_this.props.onModalClose) {
        _this.props.onModalClose();
      }
    };

    _this.handleFirstFocus = function () {
      _this.modalStructure.dialog.focus();
    };

    _this.resetFocus = function () {
      _this.trapFocus.determineFocusable(_this.modalStructure.dialog);

      _this.trapFocus.resetFocus();
    };

    _this.handleKeydown = function (e) {
      if (e.keyCode === KEYCODES.ESCAPE && _this.props.isOpen) {
        _this.props.onClose();
      } else if (e.keyCode === KEYCODES.TAB) {
        _this.trapFocus.handleTabbing(e);
      }
    };

    _this.addListeners = function () {
      if (typeof window !== 'undefined' && _this.props.closeOnEsc) {
        window.document.addEventListener('keydown', _this.handleKeydown);
      }
    };

    _this.removeListeners = function () {
      if (_this.props.closeOnEsc) {
        window.document.removeEventListener('keydown', _this.handleKeydown);
      }
    };

    _this.setLastPageYOffset = function () {
      window.reactModalLastPageYOffset = window.pageYOffset;
    };

    _this.getLastPageYOffset = function () {
      return window.reactModalLastPageYOffset;
    };

    _this.getBodyDataset = function () {
      var dataSet = window.document.body.dataset.reactModals || '{}';
      var reactModals = JSON.parse(dataSet);
      return reactModals;
    };

    _this.setBodyDataset = function (reactModals) {
      window.document.body.dataset.reactModals = JSON.stringify(reactModals);
    };

    _this.addBodyDataset = function () {
      // Get global modal data
      var reactModals = _this.getBodyDataset(); // Update instance to `OPEN` state


      reactModals[_this.stackId] = STATE_ENUM.OPEN; // Set global modal data

      _this.setBodyDataset(reactModals);
    };

    _this.removeBodyDataset = function () {
      // Get global modal data
      var reactModals = _this.getBodyDataset(); // Update instance to `CLOSING` state.


      reactModals[_this.stackId] = STATE_ENUM.CLOSING; // Set global modal data

      _this.setBodyDataset(reactModals); // While modal is transitioning out, set a timeout to allow for a brief `CLOSING` state.


      setTimeout(function () {
        // Get global modal data
        reactModals = _this.getBodyDataset(); // Remove instance from global modal data if it hasn't been re-opened again

        if (reactModals[_this.stackId] === STATE_ENUM.CLOSING) {
          // Commit delete
          delete reactModals[_this.stackId];

          _this.setBodyDataset(reactModals);
        }
      }, TIMEOUTS.modal.transitionExitTimeout + 10);
    };

    _this.hasModalsOpen = function () {
      if (typeof window !== 'undefined') {
        // Get global modal data
        var reactModals = _this.getBodyDataset(); // Filter global modal data by `OPEN` state


        var reactModalsOpen = Object.keys(reactModals).filter(function (v) {
          return reactModals[v] === STATE_ENUM.OPEN;
        }); // Return true if any modal instance data with `OPEN` state detected.

        return reactModalsOpen.length > 0;
      }

      return false;
    };

    _this.hasModalsClosing = function () {
      if (typeof window !== 'undefined') {
        // Get global modal data
        var reactModals = _this.getBodyDataset(); // Filter global modal data by `CLOSING` state


        var reactModalsOpen = Object.keys(reactModals).filter(function (v) {
          return reactModals[v] === STATE_ENUM.CLOSING;
        }); // Return true if any modal instance data with `CLOSING` state is detected

        return reactModalsOpen.length > 0;
      }

      return false;
    };

    _this.addBodyClasses = function () {
      if (typeof window !== 'undefined') {
        window.document.body.classList.add('body--modal-open'); // If modals aren't already open add necessary CSS classes to document.body element

        if (_this.props.fixedBody && !_this.hasModalsOpen()) {
          // Only store pageYOffset while we don't have fixed-position modal classes
          // attached to body to avoid obscure paint error in mobile Safari when
          // immediately opening another modal (just use previously store value)
          if (!_this.hasModalsClosing()) {
            _this.setLastPageYOffset(); // Set a delay for adding fixed-position CSS classes to body to hide background
            // page jumping from the user.


            setTimeout(_this.addMobileBodyClass, TIMEOUTS.modal.transitionEnterTimeout);
          } else {
            _this.addMobileBodyClass();
          }
        } // Add modal data to global shared state


        _this.addBodyDataset(); // Add modal CSS class to modal element


        _this.addModalBodyParentClasses();
      }
    };

    _this.addMobileBodyClass = function () {
      // UITK-307 - Prevent race condition if addMobileBodyClass called after a close event
      if (_this.hasModalsOpen()) {
        window.document.body.classList.add('body--ios-modal-open');
      }
    };

    _this.removeBodyClasses = function () {
      if (typeof window !== 'undefined') {
        // Remove modal instance from global data
        // (will update state to CLOSING, wait a short delay, then finally remove data)
        _this.removeBodyDataset(); // Remove modal CSS classes from element


        _this.removeModalBodyParentClasses(); // If modals aren't open, remove body CSS classes


        if (!_this.hasModalsOpen()) {
          // return to original opening position, if scrolled on iOS (iOS defect)
          window.document.body.classList.remove('body--modal-open');

          if (_this.props.fixedBody) {
            window.document.body.classList.remove('body--ios-modal-open'); // Scroll to previous pageYOffset when modal first opened

            window.scrollTo(0, _this.getLastPageYOffset());
          }
        }
      }
    };

    _this.openAnimation = false;
    _this.stackId = _this.props.id + "-modal-open";
    _this.focusedElementBeforeOpen = {};
    _this.trapFocus = new TrapFocus(); // Initialize global vars

    if (typeof window !== 'undefined') {
      window.reactModalLastPageYOffset = window.reactModalLastPageYOffset || 0;
    }

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.isOpen) {
      this.handleOpen();
    }
  } // Only update open modals.
  // Child content (footer and children) were causing all modals to update as state is shared
  ;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.isOpen === true || this.props.isOpen !== nextProps.isOpen || nextProps.newHeaderStyle !== this.props.newHeaderStyle) {
      return true;
    }

    return false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var callDetermineFocusable = true;
    var shouldOpen = false;
    var shouldClose = false;

    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        shouldOpen = true;
      } else {
        shouldClose = true;
      }
    }

    if (shouldOpen) {
      callDetermineFocusable = false;
      shouldOpen = false;
      this.handleOpen();
    } else if (shouldClose) {
      callDetermineFocusable = false;
      shouldClose = false;
      this.handleClose();
    } else if (this.props.scrollTop) {
      this.props.scrollToTop(this.modalBodyElement);
    } // a11y: regenerate list of focusable elements.  Not called for shouldOpen
    // as it is already called in handleOpen().  Not called in shouldClose
    // because -- it should close!


    if (this.modalStructure && this.modalStructure.dialog && callDetermineFocusable) {
      this.trapFocus.determineFocusable(this.modalStructure.dialog);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.isOpen) {
      this.handleClose();
    }
  };

  /**
   * addModalBodyParentClasses()
   * Add CSS classes to modal elements.
   */
  _proto.addModalBodyParentClasses = function addModalBodyParentClasses() {
    var openModalBodies = window.document.querySelectorAll('.Modal__body'); // for loop to handle IE 11

    for (var i = 0; i < openModalBodies.length; i++) {
      if (i !== openModalBodies.length - 1) {
        openModalBodies[i].classList.add('Modal__body--is-modal-parent');
      }
    }
  }
  /**
   * removeModalBodyParentClasses()
   * Removes CSS classes from modal elements.
   */
  ;

  _proto.removeModalBodyParentClasses = function removeModalBodyParentClasses() {
    var openModalBodies = window.document.querySelectorAll('.Modal__body'); // for loop to handle IE 11

    for (var i = 0; i < openModalBodies.length; i++) {
      if (i !== openModalBodies.length - 1) {
        openModalBodies[i].classList.remove('Modal__body--is-modal-parent');
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onModalOpen = _this$props.onModalOpen,
        onModalClose = _this$props.onModalClose,
        scrollTop = _this$props.scrollTop,
        scrollToTop = _this$props.scrollToTop,
        rest = _objectWithoutProperties(_this$props, ["onModalOpen", "onModalClose", "scrollTop", "scrollToTop"]);

    return /*#__PURE__*/React.createElement(ModalStructure, _extends({
      ref: function ref(c) {
        return _this2.modalStructure = c;
      },
      modalBodyRef: function modalBodyRef(el) {
        return _this2.modalBodyElement = el;
      } // eslint-disable-line react/jsx-no-bind
      ,
      timeouts: TIMEOUTS
    }, rest));
  };

  return Modal;
}(Component);

Modal.propTypes = _extends(_extends({}, ModalStructure.propTypes), {}, {
  /** Flag to determine if the Modal should close on pressing the Esc key. */
  closeOnEsc: PropTypes.bool,

  /** Flag to determine if the Modal should close if you click outside of it. */
  closeOnOutsideClick: PropTypes.bool,

  /** Flag to determine if body should be given a fixed position to stop scroll-behind. */
  fixedBody: PropTypes.bool,

  /** Should the modal display or not. */
  isOpen: PropTypes.bool.isRequired,

  /** Event listener to fire when the Modal has opened. */
  onModalOpen: PropTypes.func,

  /** Event listener to fire when the Modal has closed. */
  onModalClose: PropTypes.func,

  /** Event handler or action that manages changing isOpen to false within your app. */
  onClose: PropTypes.func.isRequired,

  /** The DOM element to use as the parent for the Modal when visible. This is useful in scenarios where the Modal needs to break out of its current container due to overflow or z-index issues. */
  parentNode: checkElementType,

  /** Allows you to add a classname to the Modal Portal for custom styling */
  portalClassName: PropTypes.string,

  /** A flag for determining if the modal should call scrollToTop function on property update. */
  scrollTop: PropTypes.bool,

  /** Function to be called when scrollTop is true and modal properties update. */
  scrollToTop: PropTypes.func
});
Modal.defaultProps = _extends(_extends({}, ModalStructure.defaultProps), {}, {
  closeButton: true,
  closeOnEsc: true,
  closeOnOutsideClick: true,
  closeText: 'Close',
  fixedBody: true,
  header: true,
  isInstructional: false,
  isLoading: false,
  isOpen: false,
  modalAnimation: 'modal-from-center',
  scrollTop: false,
  scrollToTop: function scrollToTop() {}
});
export default Modal;
//# sourceMappingURL=Modal.js.map